import { cx } from '@linaria/core';
import { PencilIcon } from '@ui/kit/icons';
import { contentWrapper, textBox, line } from './comp.scrambled.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { scrambledCardStyles } from '@utils/component-framework';

function ScrambledCard(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(props.className, scrambledCardStyles.wrapper),
    children: [/*#__PURE__*/jsx("h3", {
      className: scrambledCardStyles.heading,
      children: props.title
    }), /*#__PURE__*/jsxs("div", {
      className: contentWrapper,
      children: [/*#__PURE__*/jsxs("div", {
        className: textBox,
        children: [/*#__PURE__*/jsx("span", {
          className: cx(line, scrambledCardStyles.solidBox)
        }), /*#__PURE__*/jsx("span", {
          className: cx(line, scrambledCardStyles.solidBox)
        }), /*#__PURE__*/jsx("span", {
          className: cx(line, scrambledCardStyles.solidBox)
        })]
      }), /*#__PURE__*/jsx("div", {
        className: scrambledCardStyles.inputBox,
        children: /*#__PURE__*/jsx(PencilIcon, {
          height: 18
        })
      })]
    })]
  });
}

export { ScrambledCard };
//# sourceMappingURL=comp.scrambled.js.map
